import PropTypes from "prop-types";
import { UsersRound, History, Activity } from "lucide-react";

export function ContactStatsCards({ totalContacts, channelCount, conversations, activeToday }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5 sm:gap-3 min-w-0" data-testid="contact-stats">
      <div className="rounded-xl border border-slate-200 bg-white px-4 sm:px-5 py-3.5 sm:py-4 relative min-w-0">
        <div className="text-[12px] font-medium text-slate-500 pr-6">Total Contacts</div>
        <div className="mt-1 text-[24px] sm:text-[28px] font-semibold tracking-tight text-slate-900 leading-none">
          {totalContacts}
        </div>
        <div className="mt-1.5 text-[12px] text-slate-500">
          Across {channelCount} channel{channelCount === 1 ? "" : "s"}
        </div>
        <UsersRound size={16} className="absolute top-4 right-4 text-violet-500" strokeWidth={1.75} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white px-4 sm:px-5 py-3.5 sm:py-4 relative min-w-0">
        <div className="text-[12px] font-medium text-slate-500 pr-6">Conversations</div>
        <div className="mt-1 text-[24px] sm:text-[28px] font-semibold tracking-tight text-slate-900 leading-none">
          {conversations}
        </div>
        <div className="mt-1.5 text-[12px] text-slate-500">Logged to date</div>
        <History size={16} className="absolute top-4 right-4 text-sky-500" strokeWidth={1.75} />
      </div>

      <div className="rounded-xl border border-slate-200 bg-white px-4 sm:px-5 py-3.5 sm:py-4 relative min-w-0">
        <div className="text-[12px] font-medium text-slate-500 pr-6">Active Today</div>
        <div className="mt-1 text-[24px] sm:text-[28px] font-semibold tracking-tight text-slate-900 leading-none">
          {activeToday}
        </div>
        <div className="mt-1.5 text-[12px] text-emerald-600 font-medium">
          ↑ replied within 24h
        </div>
        <Activity size={16} className="absolute top-4 right-4 text-emerald-500" strokeWidth={1.75} />
      </div>
    </div>
  );
}

ContactStatsCards.propTypes = {
  totalContacts: PropTypes.number.isRequired,
  channelCount: PropTypes.number.isRequired,
  conversations: PropTypes.number.isRequired,
  activeToday: PropTypes.number.isRequired,
};
